import { createContext } from "react";
//export const NoodleModalContext = createContext<NoodleModalContextType>({});
export var SearchFilterFormContext = /*#__PURE__*/createContext({});
export var ClosestElementRegistryContext = /*#__PURE__*/createContext({});
export var IAppContext = /*#__PURE__*/createContext({});
export var FormContext = /*#__PURE__*/createContext({});
export var UploadProgressContext = /*#__PURE__*/createContext({});
export var ModalImageViewerContext = /*#__PURE__*/createContext({});
export var TableSearchBarContext = /*#__PURE__*/createContext({});